import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { CollapsibleSuggestionsPanel } from './ItemSuggestions';

export const WEDDING_ESSENTIALS_POLICY_TITLE_KEY = 'weddingPolicy.title';

const PolicyBody = styled.div`
  color: #1e293b;
  font-size: 0.95rem;
  line-height: 1.55;

  h3 {
    margin: 0.75rem 0 0.4rem;
    color: #0f172a;
    font-size: 0.95rem;
    font-weight: 700;
  }

  h3:first-child {
    margin-top: 0;
  }

  p {
    margin: 0 0 0.75rem;
    color: #334155;
  }

  ul {
    margin: 0 0 0.75rem;
    padding-left: 1.25rem;
  }

  li {
    color: #475569;
    font-size: 0.875rem;
    line-height: 1.6;
    margin-bottom: 0.35rem;
  }

  strong {
    color: #0f172a;
    font-weight: 700;
  }

  a {
    color: #0f766e;
    font-weight: 600;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
`;

const PolicyDivider = styled.hr`
  border: 0;
  border-top: 1px solid #e2e8f0;
  margin: 1rem 0;
`;

const WeddingEssentialsPolicy = ({ defaultExpanded = false }) => {
  const { t } = useTranslation();

  return (
    <CollapsibleSuggestionsPanel
      title={t(WEDDING_ESSENTIALS_POLICY_TITLE_KEY)}
      defaultExpanded={defaultExpanded}
    >
      <PolicyBody>
        <h3>{t('weddingPolicy.chooseMethod.heading')}</h3>
        <p>{t('weddingPolicy.chooseMethod.intro')}</p>
        <p>
          <strong>{t('weddingPolicy.chooseMethod.option1Title')}</strong>{' '}
          {t('weddingPolicy.chooseMethod.option1Body')}
        </p>
        <p>
          <strong>{t('weddingPolicy.chooseMethod.option2Title')}</strong>{' '}
          {t('weddingPolicy.chooseMethod.option2Body')}
        </p>

        <PolicyDivider />

        <h3>{t('weddingPolicy.fitting.heading')}</h3>
        <ul>
          <li>{t('weddingPolicy.fitting.item1')}</li>
          <li>{t('weddingPolicy.fitting.item2')}</li>
          <li>{t('weddingPolicy.fitting.item3')}</li>
          <li>{t('weddingPolicy.fitting.item4')}</li>
        </ul>

        <h3>{t('weddingPolicy.homeTryOn.heading')}</h3>
        <p>{t('weddingPolicy.homeTryOn.p1')}</p>
        <p>{t('weddingPolicy.homeTryOn.p2')}</p>
        <p>{t('weddingPolicy.homeTryOn.p3')}</p>

        <h3>{t('weddingPolicy.inspection.heading')}</h3>
        <p>{t('weddingPolicy.inspection.p1')}</p>
        <p>{t('weddingPolicy.inspection.p2')}</p>

        <h3>{t('weddingPolicy.paymentRefund.heading')}</h3>
        <p>{t('weddingPolicy.paymentRefund.intro')}</p>
        <ul>
          <li>{t('weddingPolicy.paymentRefund.item1')}</li>
          <li>{t('weddingPolicy.paymentRefund.item2')}</li>
          <li>{t('weddingPolicy.paymentRefund.item3')}</li>
        </ul>

        <h3>{t('weddingPolicy.commission.heading')}</h3>
        <p>{t('weddingPolicy.commission.p1')}</p>
        <p>{t('weddingPolicy.commission.p2')}</p>

        <h3>{t('weddingPolicy.returns.heading')}</h3>
        <ul>
          <li>{t('weddingPolicy.returns.item1')}</li>
          <li>{t('weddingPolicy.returns.item2')}</li>
          <li>{t('weddingPolicy.returns.item3')}</li>
        </ul>

        <h3>{t('weddingPolicy.damageProtection.heading')}</h3>
        <p>{t('weddingPolicy.damageProtection.intro')}</p>
        <ul>
          <li>{t('weddingPolicy.damageProtection.item1')}</li>
          <li>{t('weddingPolicy.damageProtection.item2')}</li>
          <li>{t('weddingPolicy.damageProtection.item3')}</li>
        </ul>
        <p>{t('weddingPolicy.damageProtection.closing')}</p>

        <h3>{t('weddingPolicy.support.heading')}</h3>
        <p>
          {t('weddingPolicy.support.beforeEmail')}
          <a href={`mailto:${t('weddingPolicy.support.email')}`}>
            {t('weddingPolicy.support.email')}
          </a>
          {t('weddingPolicy.support.afterEmail')}
        </p>
      </PolicyBody>
    </CollapsibleSuggestionsPanel>
  );
};

export default WeddingEssentialsPolicy;
